import { PaymentListFilter, PaymentListItem } from '@/models/dictionary/payment-list.model';
import { api } from '@/services/http.service';
import { showErrorNotification } from '@/utils/show-notification.util';
import { defineStore } from 'pinia';

interface PaymentListState {
  paymentList: PaymentListItem[];
  isPaymentListLoading: boolean;
}

export const usePaymentListStore = defineStore({
  id: 'PaymentListStore',
  state: (): PaymentListState => ({
    paymentList: [],
    isPaymentListLoading: false,
  }),
  getters: {
    uniquePaymentList: (state: PaymentListState): PaymentListItem[] => {
      return Array.from(
        new Map(state.paymentList.map((item: PaymentListItem) => [item.psp, item])).values(),
      );
    },
  },
  actions: {
    setPaymentListLoading(isLoading: boolean): void {
      this.isPaymentListLoading = isLoading;
    },
    getPaymentList(wlSlug: string, filterList?: PaymentListFilter): Promise<PaymentListItem[] | void> {
      this.setPaymentListLoading(true);

      return api.dictionary.getPaymentListRequest.perform(wlSlug, { filterList })
        .then((paymentList: PaymentListItem[]) => {
          this.paymentList = paymentList;

          return paymentList;
        })
        .catch(error => {
          showErrorNotification(error);

          return Promise.reject(error);
        })
        .finally(() => {
          this.setPaymentListLoading(false);
        });
    },
  },
});
